import { ApiService } from '@/apiConnection/ApiService';
import { Urls } from '@/apiConnection/urls';
import { CustomModalComponent } from '@/components/custom-modal/custom-modal.component';
import { LoadingComponent } from '@/components/loading/loading.component';
import { PasswordToggleComponent } from '@/components/password-toggle/password-toggle.component';
import { Utils } from '@/utils/utils';
import { HttpClient } from '@angular/common/http';
import { Component, Output, EventEmitter, ChangeDetectorRef, OnInit, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-verifactu-form',
  imports: [
    CustomModalComponent,
    ReactiveFormsModule,
    LoadingComponent,
    PasswordToggleComponent,
  ],
  templateUrl: './verifactu-form.component.html',
  styleUrl: './verifactu-form.component.scss',
})
export class VerifactuFormComponent implements OnInit {
  @Output() closeFunction = new EventEmitter<void>();
  @Output() acceptFunction = new EventEmitter<void>();

  public loading = signal(false);
  public savingAutoSend = false;
  public uploadingCert = false;
  public deletingCert = false;

  public autoSendControl = new FormControl(true);
  public certPasswordControl = new FormControl('');
  public selectedFile: File | null = null;
  public certConfigured = false;
  public certError = '';

  constructor(
    private apiService: ApiService,
    private http: HttpClient,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.loadCurrentConfig();
  }

  loadCurrentConfig() {
    this.loading.set(true);
    this.apiService.getPetition(Urls.urls.company).subscribe({
      next: (res: any) => {
        const company = res.list?.[0];
        if (company) {
          this.autoSendControl.setValue(!!company.verifactu_auto_send);
          this.certConfigured = !!company.verifactu_cert_configured;
        }
        this.loading.set(false);
        this.cdr.detectChanges();
      },
      error: () => {
        this.loading.set(false);
      }
    });
  }

  saveAutoSend() {
    this.savingAutoSend = true;
    this.apiService.save(Urls.urls.companyVerifactuAutoSend, { enabled: this.autoSendControl.value }, 0).subscribe({
      next: () => {
        Utils.notification.success('Configuración de Verifactu guardada correctamente');
        this.savingAutoSend = false;
        this.cdr.detectChanges();
      },
      error: (error: any) => {
        Utils.notification.alert(Utils.extractErrorMessage(error) || 'Error al guardar la configuración de Verifactu');
        this.savingAutoSend = false;
        this.cdr.detectChanges();
      }
    });
  }

  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.selectedFile = input.files?.[0] ?? null;
    this.certError = '';
  }

  uploadCert() {
    if (!this.selectedFile) {
      this.certError = 'Debe seleccionar el archivo del certificado (.p12/.pfx)';
      return;
    }
    if (!this.certPasswordControl.value) {
      this.certError = 'Debe indicar la contraseña del certificado';
      return;
    }

    this.uploadingCert = true;
    const fd = new FormData();
    fd.append('cert', this.selectedFile, this.selectedFile.name);
    fd.append('cert_password', this.certPasswordControl.value);

    this.apiService.upload(Urls.urls.companyVerifactuCert, fd, 0).subscribe({
      next: () => {
        Utils.notification.success('Certificado de Verifactu configurado correctamente');
        this.certConfigured = true;
        this.selectedFile = null;
        this.certPasswordControl.setValue('');
        this.uploadingCert = false;
        this.cdr.detectChanges();
      },
      error: (error: any) => {
        Utils.notification.alert(Utils.extractErrorMessage(error) || 'Error al configurar el certificado de Verifactu');
        this.uploadingCert = false;
        this.cdr.detectChanges();
      }
    });
  }

  deleteCert() {
    this.deletingCert = true;
    this.http.delete(Urls.urls.companyVerifactuCert).subscribe({
      next: () => {
        Utils.notification.success('Certificado de Verifactu eliminado correctamente');
        this.certConfigured = false;
        this.deletingCert = false;
        this.cdr.detectChanges();
      },
      error: (error: any) => {
        Utils.notification.alert(Utils.extractErrorMessage(error) || 'Error al eliminar el certificado de Verifactu');
        this.deletingCert = false;
        this.cdr.detectChanges();
      }
    });
  }

  closeFormFunction() { this.closeFunction.emit(); }
}
